import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 5rem 7rem;

  > div:last-of-type {
    width: 100% !important;
  }

  @media (max-width: 1919px) {
    padding: 5rem 5rem;
  }

  @media (max-width: 1200px) {
    padding: 5rem 3rem;
  }

  @media (max-width: 500px) {
    padding: 3rem 2rem;
  }
`;

export const Content = styled.div`
  width: 100%;

  padding: 2.5rem;

  margin-top: 5rem;
  margin-bottom: 24rem;

  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 32px 64px 0px rgba(74, 85, 104, 0.16);

  border-radius: 32px;

  z-index: 1;

  @media (max-width: 900px) {
    display: none;
  }

  @media (max-width: 500px) {
    margin-bottom: 16rem;
  }
`;

export const PlansType = styled.div`
  h2 {
    color: ${({ theme }) => theme.colors.gray6};

    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.125rem;

    margin-bottom: 1rem;
  }

  p {
    color: ${({ theme }) => theme.colors.gray5};

    font-size: 1.125rem;
    font-weight: 400;
    line-height: 150%;

    margin-bottom: 2rem;
  }

  button {
    width: 100%;
    font-size: 1rem;
  }
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0 1.5rem;

  text-align: center;

  th {
    padding: 0 2.5rem;
  }

  th:first-of-type {
    width: 50%;
  }
  th:nth-child(2) {
    width: 25%;
  }
  th:last-of-type {
    width: 25%;
  }

  td {
    color: ${({ theme }) => theme.colors.gray5};
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2rem;

    padding: 2rem;
  }

  tr {
    td:first-of-type {
      text-align: start;
    }
  }

  svg {
    width: 2rem;
    height: 2rem;
  }

  .table-title {
    td:first-of-type {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;

      font-size: 1.25rem;
      font-weight: 600;
      line-height: 160%;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }

    td {
      padding-bottom: 1.5rem !important;
    }
  }

  .table-title:not(:first-of-type) {
    td {
      padding-top: 3rem;
    }
  }

  .table-background {
    td {
      background: var(--neutral-gray-000, #f7fafc);
    }

    td:first-of-type {
      border-radius: 1rem 0 0 1rem;
    }

    td:last-of-type {
      border-radius: 0 1rem 1rem 0;
    }
  }

  @media (max-width: 1366px) {
    td {
      font-size: 1.15rem;
      line-height: 150%;

      padding: 1.5rem;
    }

    svg {
      width: 1.5rem;
      height: 1.5rem;
    }

    .table-title {
      td:first-of-type {
        font-size: 1rem;
      }

      td {
        padding-bottom: 1rem !important;
      }
    }

    .table-title:not(:first-of-type) {
      td {
        padding-top: 2rem;
      }
    }
  }

  @media (max-width: 1100px) {
    th:first-of-type {
      width: 40%;
    }
    th:nth-child(2) {
      width: 30%;
    }
    th:last-of-type {
      width: 30%;
    }
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

export const MobileContent = styled.div`
  display: none;

  width: 100%;

  margin-top: 5rem;
  margin-bottom: 24rem;

  z-index: 1;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: start;
    text-align: center;
    gap: 2rem;
  }

  @media (max-width: 500px) {
    margin-bottom: 16rem;
  }
`;

export const PlanColumn = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 64px 0px rgba(74, 85, 104, 0.16);

  border-radius: 32px;

  padding: 1.5rem;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;

  border: 1px solid ${({ theme }) => theme.colors.gray2};

  margin: 2rem 0;
`;

export const FeatureType = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  font-size: 1.25rem;
  font-weight: 600;
  line-height: 160%;
  letter-spacing: 0.1rem;
  text-transform: uppercase;

  margin-bottom: 1.5rem;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const CheckList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: start;
  gap: 1rem;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  p {
    color: ${({ theme }) => theme.colors.gray5};
    font-size: 1.15rem;
    line-height: 150%;
    font-weight: 400;
    flex: 1;
  }

  span {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }

  & + & {
    margin-top: 1rem;
  }
`;
